"use client";

import { useQuery } from "@tanstack/react-query";
import { getJSON } from "@/utils/fetcher";

interface BgtAprData {
  apr: number;
  lastUpdated: number;
}

export function useBgtApr(strike: bigint | string | undefined) {
  const enabled = Boolean(strike);
  const str = typeof strike === "bigint" ? strike.toString() : strike;

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["bgt-apr", str],
    enabled,
    queryFn: () => getJSON<BgtAprData>(`/api/earn/bgt-aprs`, { query: { strike: str! } }),
    staleTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
  });

  return {
    aprData: data ?? null,
    isLoading,
    error: error ? "Failed to fetch APR data" : null,
    refetch,
  } as const;
}
